export const get_first_xter = (data: string) => {
  return data[0];
};
